import { ProfileIconLight } from './ProfileIconLight';

export default ProfileIconLight;
